// import { FC } from 'react';
// import { Modal } from 'react-bootstrap';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }

// export const RecyclerAddress: FC<UserTableModalProps> = ({ user, onClose, show }) => {
//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={onClose}>
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">Address Details</h1>
//                     </div>

//                     <div className="table-responsive">
//                         {/* <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
//                             <thead>
//                                 <tr className="fw-bold text-muted bg-light">
//                                     <th className="min-w-100px ps-4">Street</th>
//                                     <th className="min-w-100px">City</th>
//                                     <th className="min-w-100px">State</th>
//                                     <th className="min-w-100px">Country</th>
//                                     <th className="min-w-100px rounded-end">Zip Code</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr>
//                                     <td className="ps-4">
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.address?.[0]?.street || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.address?.[0]?.city || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.address?.[0]?.state || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.address?.[0]?.country || 'N/A'}
//                                         </span>
//                                     </td>
//                                     <td>
//                                         <span className="text-dark fw-semibold d-block fs-6">
//                                             {user?.address?.[0]?.zipCode || 'N/A'}
//                                         </span>
//                                     </td>
//                                 </tr>
//                             </tbody>
//                         </table> */}

//                         <div className="table-responsive">
//                             <table style={{
//                                 width: "100%",
//                                 borderCollapse: "collapse",
//                                 marginBottom: "20px",
//                                 border: "1px solid #ddd"
//                             }}>
//                                 <thead>
//                                     <tr>
//                                         <th colSpan={2} style={{
//                                             backgroundColor: "#BFD7ED",
//                                             color: "black",
//                                             fontWeight: "bold",
//                                             padding: "12px",
//                                             textAlign: "left",
//                                             border: "1px solid #ddd"
//                                         }}>
//                                             Address Details
//                                         </th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr>
//                                         <td style={{
//                                             width: "33%",
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Street
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.address?.[0]?.street || 'N/A'}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             City
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.address?.[0]?.city || 'N/A'}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             State
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.address?.[0]?.state || 'N/A'}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Country
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.address?.[0]?.country || 'N/A'}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Zip Code
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {user?.address?.[0]?.zipCode || 'N/A'}
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>

//                     </div>

//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={onClose}
//                         >
//                             Close
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };









// import { FC, useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import { useAuth } from '../../../../../auth';
// import { useLocation } from 'react-router-dom';

// interface UserTableModalProps {
//     user: any;
//     onClose: () => void;
//     show: boolean;
// }

// export const RecyclerAddress: FC<UserTableModalProps> = ({ user, onClose, show }) => {


//     const { currentUser } = useAuth()
//     const isAdmin = (currentUser as any)?.role?.name === "ADMIN_CXO";

//     const location = useLocation();
//     const isRecyclerPath = location.pathname.includes('/apps/business/recycler');
//     const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point');
//     const canEdit = isAdmin && (isRecyclerPath || isCollectionPointPath);

//     const [addressFields, setAddressFields] = useState({
//         street: '',
//         city: '',
//         state: '',
//         country: '',
//         zipCode: ''
//     });

//     const [originalFields, setOriginalFields] = useState({
//         street: '',
//         city: '',
//         state: '',
//         country: '',
//         zipCode: ''
//     });

//     const [hasChanges, setHasChanges] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);

//     // Initialize fields when user data changes
//     useEffect(() => {
//         if (user?.address?.[0]) {
//             const initialFields = {
//                 street: user.address[0].street || '',
//                 city: user.address[0].city || '',
//                 state: user.address[0].state || '',
//                 country: user.address[0].country || '',
//                 zipCode: user.address[0].zipCode || ''
//             };
//             setAddressFields(initialFields);
//             setOriginalFields(initialFields);
//         }
//     }, [user]);

//     // Check for changes whenever fields update
//     useEffect(() => {
//         const fieldsChanged = Object.keys(addressFields).some(
//             key => addressFields[key as keyof typeof addressFields] !== originalFields[key as keyof typeof originalFields]
//         );
//         setHasChanges(fieldsChanged);
//     }, [addressFields, originalFields]);

//     const handleFieldChange = (field: keyof typeof addressFields, value: string) => {
//         setAddressFields(prev => ({
//             ...prev,
//             [field]: value
//         }));
//     };

//     // const handleSave = async () => {
//     //     if (!hasChanges || !user?.id) return;

//     //     setIsLoading(true);
//     //     try {
//     //         // Create updated user object with modified address
//     //         const updatedUser = {
//     //             pickupPointStaffId: user.pickupPointStaffId,
//     //             pickupPointStaffName: user.pickupPointStaffName,
//     //             firstName: user.personalDetails?.name || "",
//     //             email: user.personalDetails?.email || "",
//     //             mobile: user.personalDetails?.mobile || "",
//     //             userType: "PICKUP_POINT",
//     //             countryCode: "91",
//     //             franchiseId: user.franchiseId || "",
//     //             status: "ACTIVE",
//     //             kycDocument: [
//     //                 {
//     //                     docUrl: user.kycDocument?.[0]?.docUrl || "",
//     //                     docNumber: user.kycDocument?.[0]?.docNumber || "",
//     //                     docType: "CIN"
//     //                 },
//     //                 {
//     //                     docUrl: user.kycDocument?.[1]?.docUrl || "",
//     //                     docNumber: user.kycDocument?.[1]?.docNumber || "",
//     //                     docType: "AADHAR"
//     //                 },
//     //                 {
//     //                     docUrl: user.kycDocument?.[2]?.docUrl || "",
//     //                     docNumber: user.kycDocument?.[2]?.docNumber || "",
//     //                     docType: "GST_NUMBER"
//     //                 },
//     //                 {
//     //                     docUrl: user.kycDocument?.[3]?.docUrl || "",
//     //                     docNumber: user.kycDocument?.[3]?.docNumber || "",
//     //                     docType: "PAN"
//     //                 }
//     //             ],
//     //             companyDetails: {
//     //                 name: user.companyDetails?.name || "",
//     //                 companyId: user.companyDetails?.companyId || ""
//     //             },
//     //             address: [
//     //                 {
//     //                     addressType: "OFFICE_ADDRESS",
//     //                     street: addressFields.street,
//     //                     city: addressFields.city,
//     //                     zipCode: addressFields.zipCode,
//     //                     country: addressFields.country,
//     //                     state: addressFields.state
//     //                 }
//     //             ],
//     //             bankDetails: {
//     //                 bankName: user.bankDetails?.bankName || "",
//     //                 accountNo: user.bankDetails?.accountNo || "",
//     //                 ifscCode: user.bankDetails?.ifscCode || "",
//     //                 accountName: user.bankDetails?.accountName || "",
//     //                 images: [
//     //                     {
//     //                         docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
//     //                         docType: "CANCEL_CHEQUE"
//     //                     }
//     //                 ]
//     //             }
//     //           };

//     //         const response = await fetch(`https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`, {
//     //             method: 'PUT', // or 'PATCH' depending on your API
//     //             headers: {
//     //                 'Content-Type': 'application/json',
//     //                 // Add any authentication headers if needed
//     //                 // 'Authorization': `Bearer ${token}`
//     //             },
//     //             body: JSON.stringify(updatedUser)
//     //         });

//     //         if (!response.ok) {
//     //             throw new Error('Failed to update user');
//     //         }

//     //         const result = await response.json();

//     //         // Update original fields to reflect saved state
//     //         setOriginalFields(addressFields);
//     //         setHasChanges(false);

//     //         console.log('User updated successfully:', result);
//     //         // You might want to show a success message here

//     //     } catch (error) {
//     //         console.error('Error updating user:', error);
//     //         // You might want to show an error message here
//     //     } finally {
//     //         setIsLoading(false);
//     //     }
//     // };




//     const handleSave = async () => {
//         if (!hasChanges || !user?.id) return;

//         setIsLoading(true);
//         try {
//             let updatedPayload;
//             let apiUrl;

//             if (isRecyclerPath) {
//                 // Recycler payload
//                 updatedPayload = {
//                     firstName: user.personalDetails?.name || "",
//                     email: user.personalDetails?.email || "",
//                     mobile: user.personalDetails?.mobile || "",
//                     userType: "RECYCLER",
//                     countryCode: "91",
//                     franchiseId: "",
//                     status: "ACTIVE",
//                     kycDocument: [
//                         {
//                             docUrl: user.kycDocument?.find(doc => doc.docType === 'AADHAR')?.docUrl || "",
//                             docNumber: user.kycDocument?.find(doc => doc.docType === 'AADHAR')?.docNumber || "",
//                             docType: "AADHAR"
//                         },
//                         {
//                             docUrl: user.kycDocument?.find(doc => doc.docType === 'GST_CERTIFICATE')?.docUrl || "",
//                             docNumber: user.kycDocument?.find(doc => doc.docType === 'GST_CERTIFICATE')?.docNumber || "",
//                             docType: "GST_CERTIFICATE"
//                         },
//                         {
//                             docUrl: user.kycDocument?.find(doc => doc.docType === 'PAN')?.docUrl || "",
//                             docNumber: user.kycDocument?.find(doc => doc.docType === 'PAN')?.docNumber || "",
//                             docType: "PAN"
//                         },
//                         {
//                             docUrl: user.kycDocument?.find(doc => doc.docType === 'MSME_CERTIFICATE')?.docUrl || "",
//                             docNumber: user.kycDocument?.find(doc => doc.docType === 'MSME_CERTIFICATE')?.docNumber || "",
//                             docType: "MSME_CERTIFICATE"
//                         }
//                     ],
//                     companyDetails: {
//                         name: user.companyDetails?.name || "",
//                         companyId: user.companyDetails?.companyId || "",
//                     },
//                     address: [
//                         {
//                             addressType: "OFFICE_ADDRESS",
//                             city: addressFields.city,
//                             state: addressFields.state,
//                             country: addressFields.country,
//                             zipCode: addressFields.zipCode,
//                             street: addressFields.street,
//                             latitute: user.address?.[0]?.latitute || 0,
//                             longitute: user.address?.[0]?.longitute || 0,
//                         }
//                     ],
//                     bankDetails: {
//                         bankName: user.bankDetails?.bankName || "",
//                         accountNo: user.bankDetails?.accountNo || "",
//                         ifscCode: user.bankDetails?.ifscCode || "",
//                         accountName: user.bankDetails?.accountName || "",
//                         images: [
//                             {
//                                 docUrl: user.bankDetails?.images?.find(img => img.docType === 'CHEQUE_CERTIFICATE')?.docUrl || "",
//                                 docType: "CANCEL_CHEQUE"
//                             }
//                         ]
//                     }
//                 };
//                 apiUrl = `https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`;
//             } else {
//                 // Collection point payload (existing logic)
//                 updatedPayload = {
//                     pickupPointStaffId: user.pickupPointStaffId,
//                     pickupPointStaffName: user.pickupPointStaffName,
//                     firstName: user.personalDetails?.name || "",
//                     email: user.personalDetails?.email || "",
//                     mobile: user.personalDetails?.mobile || "",
//                     userType: "PICKUP_POINT",
//                     countryCode: "91",
//                     franchiseId: user.franchiseId || "",
//                     status: "ACTIVE",
//                     kycDocument: [
//                         {
//                             docUrl: user.kycDocument?.[0]?.docUrl || "",
//                             docNumber: user.kycDocument?.[0]?.docNumber || "",
//                             docType: "CIN"
//                         },
//                         {
//                             docUrl: user.kycDocument?.[1]?.docUrl || "",
//                             docNumber: user.kycDocument?.[1]?.docNumber || "",
//                             docType: "AADHAR"
//                         },
//                         {
//                             docUrl: user.kycDocument?.[2]?.docUrl || "",
//                             docNumber: user.kycDocument?.[2]?.docNumber || "",
//                             docType: "GST_NUMBER"
//                         },
//                         {
//                             docUrl: user.kycDocument?.[3]?.docUrl || "",
//                             docNumber: user.kycDocument?.[3]?.docNumber || "",
//                             docType: "PAN"
//                         }
//                     ],
//                     companyDetails: {
//                         name: user.companyDetails?.name || "",
//                         companyId: user.companyDetails?.companyId || ""
//                     },
//                     address: [
//                         {
//                             addressType: "OFFICE_ADDRESS",
//                             street: addressFields.street,
//                             city: addressFields.city,
//                             zipCode: addressFields.zipCode,
//                             country: addressFields.country,
//                             state: addressFields.state
//                         }
//                     ],
//                     bankDetails: {
//                         bankName: user.bankDetails?.bankName || "",
//                         accountNo: user.bankDetails?.accountNo || "",
//                         ifscCode: user.bankDetails?.ifscCode || "",
//                         accountName: user.bankDetails?.accountName || "",
//                         images: [
//                             {
//                                 docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
//                                 docType: "CANCEL_CHEQUE"
//                             }
//                         ]
//                     }
//                 };
//                 apiUrl = `https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`;
//             }

//             const response = await fetch(apiUrl, {
//                 method: 'PUT',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(updatedPayload)
//             });

//             // ... rest of your existing code
//         } catch (error) {
//             // ... existing error handling
//         }
//     };


//     const handleClose = () => {
//         // Reset fields to original values when closing
//         setAddressFields(originalFields);
//         setHasChanges(false);
//         onClose();
//     };

//     return (
//         <Modal
//             className='modal fade'
//             id='kt_modal_view_user'
//             data-backdrop='static'
//             tabIndex={-1}
//             role='dialog'
//             show={show}
//             centered
//             size="lg"
//         >
//             <div className="modal-content">
//                 <div className="modal-header pb-0 border-0 justify-content-end">
//                     <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
//                         ×
//                     </div>
//                 </div>

//                 <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
//                     <div className="text-center mb-13">
//                         <h1 className="mb-3">Address Details</h1>
//                     </div>

//                     <div className="table-responsive">
//                         <div className="table-responsive">
//                             <table style={{
//                                 width: "100%",
//                                 borderCollapse: "collapse",
//                                 marginBottom: "20px",
//                                 border: "1px solid #ddd"
//                             }}>
//                                 <thead>
//                                     <tr>
//                                         <th colSpan={2} style={{
//                                             backgroundColor: "#BFD7ED",
//                                             color: "black",
//                                             fontWeight: "bold",
//                                             padding: "12px",
//                                             textAlign: "left",
//                                             border: "1px solid #ddd"
//                                         }}>
//                                             Address Details
//                                         </th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     <tr>
//                                         <td style={{
//                                             width: "33%",
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Street
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {canEdit ? (
//                                                 <input
//                                                     type="text"
//                                                     value={addressFields.street}
//                                                     onChange={(e) => handleFieldChange('street', e.target.value)}
//                                                     style={{
//                                                         width: "100%",
//                                                         border: "1px solid #ccc",
//                                                         borderRadius: "4px",
//                                                         padding: "8px",
//                                                         fontSize: "14px"
//                                                     }}
//                                                     placeholder="Enter street address"
//                                                 />
//                                             ) : (
//                                                 <span>{addressFields.street || 'N/A'}</span>
//                                             )}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             City
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {canEdit ? (
//                                                 <input
//                                                     type="text"
//                                                     value={addressFields.city}
//                                                     onChange={(e) => handleFieldChange('city', e.target.value)}
//                                                     style={{
//                                                         width: "100%",
//                                                         border: "1px solid #ccc",
//                                                         borderRadius: "4px",
//                                                         padding: "8px",
//                                                         fontSize: "14px"
//                                                     }}
//                                                     placeholder="Enter city"
//                                                 />
//                                             ) : (
//                                                 <span>{addressFields.city || 'N/A'}</span>
//                                             )}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             State
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {canEdit ? (
//                                                 <input
//                                                     type="text"
//                                                     value={addressFields.state}
//                                                     onChange={(e) => handleFieldChange('state', e.target.value)}
//                                                     style={{
//                                                         width: "100%",
//                                                         border: "1px solid #ccc",
//                                                         borderRadius: "4px",
//                                                         padding: "8px",
//                                                         fontSize: "14px"
//                                                     }}
//                                                     placeholder="Enter state"
//                                                 />
//                                             ) : (
//                                                 <span>{addressFields.state || 'N/A'}</span>
//                                             )}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Country
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {canEdit ? (
//                                                 <input
//                                                     type="text"
//                                                     value={addressFields.country}
//                                                     onChange={(e) => handleFieldChange('country', e.target.value)}
//                                                     style={{
//                                                         width: "100%",
//                                                         border: "1px solid #ccc",
//                                                         borderRadius: "4px",
//                                                         padding: "8px",
//                                                         fontSize: "14px"
//                                                     }}
//                                                     placeholder="Enter country"
//                                                 />
//                                             ) : (
//                                                 <span>{addressFields.country || 'N/A'}</span>
//                                             )}
//                                         </td>
//                                     </tr>
//                                     <tr>
//                                         <td style={{
//                                             padding: "10px",
//                                             border: "1px solid #ddd",
//                                             fontWeight: "bold"
//                                         }}>
//                                             Zip Code
//                                         </td>
//                                         <td style={{ padding: "10px", border: "1px solid #ddd" }}>
//                                             {canEdit ? (
//                                                 <input
//                                                     type="text"
//                                                     value={addressFields.zipCode}
//                                                     onChange={(e) => handleFieldChange('zipCode', e.target.value)}
//                                                     style={{
//                                                         width: "100%",
//                                                         border: "1px solid #ccc",
//                                                         borderRadius: "4px",
//                                                         padding: "8px",
//                                                         fontSize: "14px"
//                                                     }}
//                                                     placeholder="Enter zip code"
//                                                 />
//                                             ) : (
//                                                 <span>{addressFields.zipCode || 'N/A'}</span>
//                                             )}
//                                         </td>
//                                     </tr>
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>

//                     <div className="modal-footer">
//                         <button
//                             type="button"
//                             className="btn btn-light"
//                             onClick={handleClose}
//                         >
//                             Close
//                         </button>
//                         {canEdit && (
//                             <button
//                                 type="button"
//                                 className={`btn ${hasChanges ? 'btn-primary' : 'btn-secondary'}`}
//                                 onClick={handleSave}
//                                 disabled={!hasChanges || isLoading}
//                                 style={{
//                                     marginLeft: "10px",
//                                     opacity: hasChanges ? 1 : 0.6,
//                                     cursor: hasChanges ? 'pointer' : 'not-allowed'
//                                 }}
//                             >
//                                 {isLoading ? 'Saving...' : 'Save Changes'}
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </Modal>
//     );
// };




















import { FC, useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useAuth } from '../../../../../auth';
import { useLocation } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
// import CountryDropDown from '../../../../../../_metronic/helpers/countryDropDown';
import CountryDropDown from '../../../../../../../_metronic/helpers/countryDropDown';
// import { successToast } from '../../../../../../_metronic/helpers/components/Toaster'
import { successToast } from '../../../../../../../_metronic/helpers/components/Toaster';

interface UserTableModalProps {
    user: any;
    onClose: () => void;
    show: boolean;
}

const addressSchema = Yup.object().shape({
    street: Yup.string().required('Street is required'),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    country: Yup.string().required('Country is required'),
    zipCode: Yup.string().required('Zip Code is required'),
});




const stateCodeMapping = {
    'Andaman and Nicobar Islands': 'AN',
    'Andhra Pradesh': 'AP',
    'Arunachal Pradesh': 'AR',
    'Assam': 'AS',
    'Bihar': 'BH',
    'Chandigarh': 'CH',
    'Chhattisgarh': 'CT',
    'Dadra and Nagar Haveli': 'DN',
    'Daman and Diu': 'DD',
    'Delhi': 'DL',
    'Goa': 'GA',
    'Gujarat': 'GJ',
    'Haryana': 'HR',
    'Himachal Pradesh': 'HP',
    'Jammu and Kashmir': 'JK',
    'Jharkhand': 'JH',
    'Karnataka': 'KA',
    'Kerala': 'KL',
    'Lakshadweep': 'LD',
    'Madhya Pradesh': 'MP',
    'Maharashtra': 'MH',
    'Manipur': 'MN',
    'Meghalaya': 'ME',
    'Mizoram': 'MI',
    'Nagaland': 'NL',
    'Odisha': 'OR',
    'Puducherry': 'PY',
    'Punjab': 'PB',
    'Rajasthan': 'RJ',
    'Sikkim': 'SK',
    'Tamil Nadu': 'TN',
    'Telangana': 'TS',
    'Tripura': 'TR',
    'Uttar Pradesh': 'UP',
    'Uttarakhand': 'UT',
    'West Bengal': 'WB'
};














export const RecyclerAddress: FC<UserTableModalProps> = ({ user, onClose, show }) => {
    const { currentUser } = useAuth()
    const isAdmin = (currentUser as any)?.role?.name === "ADMIN_CXO";

    const location = useLocation();
    const isRecyclerPath = location.pathname.includes('/apps/business/recycler');
    const isRecyclerPathFinance = location.pathname.includes('/apps/finance/recycler');
    const isCollectionPointPath = location.pathname.includes('/apps/business/collection-point');
    const isCollectionPointPathFinance = location.pathname.includes('/apps/finance/collection-point');
    // const canEdit = isAdmin && (isRecyclerPath || isCollectionPointPath);
    const canEdit = isAdmin && (isRecyclerPath || isRecyclerPathFinance || isCollectionPointPath || isCollectionPointPathFinance);

    const [isLoading, setIsLoading] = useState(false);
    const [formInitialized, setFormInitialized] = useState(false);

    // Get initial values from user data
    const getInitialValues = () => {
        // console.log('=== GETTING INITIAL VALUES ===');
        // console.log('Full user object:', user);
        // console.log('User address array:', user?.address);
        // console.log('First address object:', user?.address?.[0]);

        // Get address data from the correct path
        const address = user?.address?.[0] || {};

        const initialValues = {
            street: address?.street || '',
            city: address?.city || '',
            state: address?.state || address?.stateName || '', // Handle null state
            country: address?.country || '',
            zipCode: address?.zipCode || '',
            stateCode: address?.stateCode || '' // Add this line
        };

        console.log('Extracted initial values:', initialValues);
        console.log('Address object keys:', Object.keys(address));
        console.log('Raw address data:', address);
        return initialValues;
    };

    // Initialize formik with address data
    const formik = useFormik({
        initialValues: getInitialValues(),
        // validationSchema: addressSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            await handleSave(values);
        }
    });



    // Add this useEffect to watch for state changes
    useEffect(() => {
        if (formik.values.state && formik.values.country === 'India') {
            const code = stateCodeMapping[formik.values.state];
            if (code) {
                formik.setFieldValue('stateCode', code);
            }
        }
    }, [formik.values.state, formik.values.country]);

    // Force re-initialization when user changes or modal opens
    useEffect(() => {
        if (show && user && user.address && user.address[0]) {
            console.log('=== FORCE INITIALIZING FORM ===');
            const address = user.address[0];
            console.log('Address data:', address);

            // Add a small delay to ensure CountryDropDown is ready
            setTimeout(() => {
                // Set values with more detailed logging
                if (address.street) {
                    console.log('Setting street:', address.street);
                    formik.setFieldValue('street', address.street);
                }
                if (address.city) {
                    console.log('Setting city:', address.city);
                    formik.setFieldValue('city', address.city);
                }
                if (address.state) {
                    console.log('Setting state:', address.state);
                    formik.setFieldValue('state', address.state);
                } else {
                    console.log('State is null, not setting');
                }
                if (address.country) {
                    console.log('Setting country:', address.country);
                    formik.setFieldValue('country', address.country);
                }
                if (address.zipCode) {
                    console.log('Setting zipCode:', address.zipCode);
                    formik.setFieldValue('zipCode', address.zipCode);
                }

                setFormInitialized(true);
            }, 100);
        }
    }, [show, user]);

    // Reset form initialization when modal closes
    useEffect(() => {
        if (!show) {
            setFormInitialized(false);
        }
    }, [show]);

    // Debug current formik values
    useEffect(() => {
        console.log('=== CURRENT FORMIK VALUES ===');
        console.log(formik.values);
    }, [formik.values]);

    const handleSave = async (values: any) => {
        if (!user?.id) return;

        setIsLoading(true);
        try {
            let updatedPayload;
            let apiUrl;

            if (isRecyclerPath || isRecyclerPathFinance) {
                // Recycler payload
                updatedPayload = {
                    firstName: user.personalDetails?.name || "",
                    email: user.personalDetails?.email || "",
                    mobile: user.personalDetails?.mobile || "",
                    userType: "RECYCLER",
                    countryCode: "91",
                    franchiseId: "",
                    status: "ACTIVE",
                    kycDocument: [
                        {
                            docUrl: user.kycDocument?.find(doc => doc.docType === 'AADHAR')?.docUrl || "",
                            docNumber: user.kycDocument?.find(doc => doc.docType === 'AADHAR')?.docNumber || "",
                            docType: "AADHAR"
                        },
                        {
                            docUrl: user.kycDocument?.find(doc => doc.docType === 'GST_CERTIFICATE')?.docUrl || "",
                            docNumber: user.kycDocument?.find(doc => doc.docType === 'GST_CERTIFICATE')?.docNumber || "",
                            docType: "GST_CERTIFICATE"
                        },
                        {
                            docUrl: user.kycDocument?.find(doc => doc.docType === 'PAN')?.docUrl || "",
                            docNumber: user.kycDocument?.find(doc => doc.docType === 'PAN')?.docNumber || "",
                            docType: "PAN"
                        },
                        {
                            docUrl: user.kycDocument?.find(doc => doc.docType === 'MSME_CERTIFICATE')?.docUrl || "",
                            docNumber: user.kycDocument?.find(doc => doc.docType === 'MSME_CERTIFICATE')?.docNumber || "",
                            docType: "MSME_CERTIFICATE"
                        }
                    ],
                    companyDetails: {
                        name: user.companyDetails?.name || "",
                        companyId: user.companyDetails?.companyId || "",
                    },
                    address: [
                        {
                            addressType: "OFFICE_ADDRESS",
                            stateCode: values.stateCode,
                            city: values.city,
                            state: values.state,
                            country: values.country,
                            zipCode: values.zipCode,
                            street: values.street,
                            latitute: user.address?.[0]?.latitute || 0,
                            longitute: user.address?.[0]?.longitute || 0,
                        }
                    ],
                    bankDetails: {
                        bankName: user.bankDetails?.bankName || "",
                        accountNo: user.bankDetails?.accountNo || "",
                        ifscCode: user.bankDetails?.ifscCode || "",
                        accountName: user.bankDetails?.accountName || "",
                        // images: [
                        //     {
                        //         docUrl: user.bankDetails?.images?.find(img => img.docType === 'CHEQUE_CERTIFICATE')?.docUrl || "",
                        //         docType: "CANCEL_CHEQUE"
                        //     }
                        // ]
                        images: [
                            {
                                docUrl: user.bankDetails?.images?.find(img =>
                                    img.docType === 'CHEQUE_CERTIFICATE' || img.docType === 'CANCEL_CHEQUE'
                                )?.docUrl || user.bankDetails?.images?.[0]?.docUrl || "",
                                docType: "CANCEL_CHEQUE"
                            }
                        ]
                    }
                };
                apiUrl = `https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`;
            } else {
                // Collection point payload (existing logic)
                updatedPayload = {
                    pickupPointStaffId: user.pickupPointStaffId,
                    pickupPointStaffName: user.pickupPointStaffName,
                    firstName: user.personalDetails?.name || "",
                    email: user.personalDetails?.email || "",
                    mobile: user.personalDetails?.mobile || "",
                    userType: "PICKUP_POINT",
                    countryCode: "91",
                    franchiseId: user.franchiseId || "",
                    status: "ACTIVE",
                    kycDocument: [
                        {
                            docUrl: user.kycDocument?.[0]?.docUrl || "",
                            docNumber: user.kycDocument?.[0]?.docNumber || "",
                            docType: "CIN"
                        },
                        {
                            docUrl: user.kycDocument?.[1]?.docUrl || "",
                            docNumber: user.kycDocument?.[1]?.docNumber || "",
                            docType: "AADHAR"
                        },
                        {
                            docUrl: user.kycDocument?.[2]?.docUrl || "",
                            docNumber: user.kycDocument?.[2]?.docNumber || "",
                            docType: "GST_NUMBER"
                        },
                        {
                            docUrl: user.kycDocument?.[3]?.docUrl || "",
                            docNumber: user.kycDocument?.[3]?.docNumber || "",
                            docType: "PAN"
                        }
                    ],
                    companyDetails: {
                        name: user.companyDetails?.name || "",
                        companyId: user.companyDetails?.companyId || ""
                    },
                    address: [
                        {
                            addressType: "OFFICE_ADDRESS",
                            street: values.street,
                            city: values.city,
                            zipCode: values.zipCode,
                            country: values.country,
                            state: values.state
                        }
                    ],
                    bankDetails: {
                        bankName: user.bankDetails?.bankName || "",
                        accountNo: user.bankDetails?.accountNo || "",
                        ifscCode: user.bankDetails?.ifscCode || "",
                        accountName: user.bankDetails?.accountName || "",
                        images: [
                            {
                                docUrl: user.bankDetails?.images?.[0]?.docUrl || "",
                                docType: "CANCEL_CHEQUE"
                            }
                        ]
                    }
                };
                apiUrl = `https://pfc-backend-api.asmglobal.co.in/v1/api/users/${user.id}/update`;
            }

            const response = await fetch(apiUrl, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(updatedPayload)
            });

            if (!response.ok) {
                throw new Error('Failed to update user');
            }

            const result = await response.json();
            console.log('User updated successfully:', result);
            successToast('Modified');

            // Reset form dirty state
            formik.resetForm({ values: formik.values });
            setTimeout(() => {
                window.location.reload();
            }, 1500);

        } catch (error) {
            console.error('Error updating user:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        // Reset form to initial values when closing
        formik.resetForm();
        setFormInitialized(false);
        onClose();
    };

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
                        X
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">Address Details</h1>
                    </div>

                    <form onSubmit={formik.handleSubmit}>
                        <div className="table-responsive">
                            <table style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                marginBottom: "20px",
                                border: "1px solid #ddd"
                            }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} style={{
                                            backgroundColor: "#BFD7ED",
                                            color: "black",
                                            fontWeight: "bold",
                                            padding: "12px",
                                            textAlign: "left",
                                            border: "1px solid #ddd"
                                        }}>
                                            Address Details
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{
                                            width: "33%",
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Street
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {canEdit ? (
                                                <div>
                                                    <input
                                                        type="text"
                                                        {...formik.getFieldProps('street')}
                                                        style={{
                                                            width: "100%",
                                                            border: formik.values.street === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                            borderRadius: "4px",
                                                            padding: "8px",
                                                            fontSize: "14px"
                                                        }}
                                                        placeholder="Enter street address"
                                                    />
                                                    {formik.touched.street && formik.errors.street && (
                                                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                            {/* {formik.errors.street} */}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <span>{formik.values.street || 'N/A'}</span>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{
                                            width: "33%",
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            fontWeight: "bold"
                                        }}>
                                            Zip Code
                                        </td>
                                        <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                            {canEdit ? (
                                                <div>
                                                    <input
                                                        type="text"
                                                        {...formik.getFieldProps('zipCode')}
                                                        style={{
                                                            width: "100%",
                                                            border: formik.values.zipCode === '' ? "2px solid #fdb2c5" : "1px solid #ccc",
                                                            borderRadius: "4px",
                                                            padding: "8px",
                                                            fontSize: "14px"
                                                        }}
                                                        placeholder="Enter zip code"
                                                    />
                                                    {formik.touched.zipCode && formik.errors.zipCode && (
                                                        <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                            {/* {formik.errors.zipCode} */}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <span>{formik.values.zipCode || 'N/A'}</span>
                                            )}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Country, State, City dropdowns outside table when in edit mode */}
                        {canEdit && (
                            <div style={{ marginBottom: '20px' }}>
                                <h4 style={{ marginBottom: '15px', color: '#333' }}>Location Details</h4>
                                <CountryDropDown
                                    showState={true}
                                    showCity={true}
                                    name='country'
                                    formik={formik}
                                    showNameOnly={true}
                                />
                            </div>
                        )}

                        {/* Display table for country, state, city when not in edit mode */}
                        {!canEdit && (
                            <div className="table-responsive">
                                <table style={{
                                    width: "100%",
                                    borderCollapse: "collapse",
                                    marginBottom: "20px",
                                    border: "1px solid #ddd"
                                }}>
                                    <thead>
                                        <tr>
                                            <th colSpan={2} style={{
                                                backgroundColor: "#BFD7ED",
                                                color: "black",
                                                fontWeight: "bold",
                                                padding: "12px",
                                                textAlign: "left",
                                                border: "1px solid #ddd"
                                            }}>
                                                Location Details
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{
                                                width: "33%",
                                                padding: "10px",
                                                border: "1px solid #ddd",
                                                fontWeight: "bold"
                                            }}>
                                                Country
                                            </td>
                                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                <span>{formik.values.country || 'N/A'}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                padding: "10px",
                                                border: "1px solid #ddd",
                                                fontWeight: "bold"
                                            }}>
                                                State
                                            </td>
                                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                <span>{formik.values.state || 'N/A'}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{
                                                padding: "10px",
                                                border: "1px solid #ddd",
                                                fontWeight: "bold"
                                            }}>
                                                City
                                            </td>
                                            <td style={{ padding: "10px", border: "1px solid #ddd" }}>
                                                <span>{formik.values.city || 'N/A'}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                onClick={handleClose}
                            >
                                Close
                            </button>
                            {canEdit && (
                                <button
                                    type="submit"
                                    className={`btn ${formik.dirty ? 'btn-primary' : 'btn-secondary'}`}
                                    disabled={!formik.dirty || isLoading || !formik.isValid}
                                    style={{
                                        marginLeft: "10px",
                                        opacity: formik.dirty ? 1 : 0.6,
                                        cursor: formik.dirty ? 'pointer' : 'not-allowed'
                                    }}
                                >
                                    {isLoading ? 'Saving...' : 'Save Changes'}
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};